export const userAccount = {
  loginForm: {
    forgotPassword: 'Mot de passe oublié?',
    signIn: 'Se connecter',
    register: 'S\'inscrire',
    signUp: 'S\'inscrire',
    wrongEmailFormat: 'Ce format de courriel n\'est pas valide.',
    guestCheckout: 'Passer la commande en tant qu\'invité',
    dontHaveAccount: 'Vous n\'avez pas de compte?',
    emailAddress: {
      label: 'Adresse courriel',
      placeholder: 'Saisir le courriel',
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Mot de passe',
    },
  },
  miniLogin: {
    userGreeting: 'Bonjour, {{name}}',
    signInRegister: 'Se connecter / S\'inscrire',
  },
  authMessages: {
    signedOutSuccessfully: 'Déconnexion réussie.',
  },
};

export const userRegister = {
  register: {
    confirmPassword: {
      action: 'Confirmer le mot de passe',
      label: 'Confirmer le mot de passe',
      placeholder: 'Confirmer le mot de passe',
    },
    managementInMyAccount: 'Gestion dans Mon compte.',
    termsAndConditions: 'Modalités et conditions',
    signIn: 'J\'ai déjà un compte. Se connecter',
    register: 'S\'inscrire',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    createAccount: 'Créer un compte',
    title: 'Titre',
    firstName: {
      label: 'Prénom',
      placeholder: 'Prénom',
    },
    lastName: {
      label: 'Nom de famille',
      placeholder: 'Nom de famille',
    },
    emailAddress: {
      label: 'Adresse courriel',
      placeholder: 'Adresse courriel',
    },
    confEmailAddress: {
      label: 'Confirmer l\'adresse courriel',
      placeholder: 'Confirmer l\'adresse courriel',
    },
    accountNumber: {
      label: 'Numéro de compte',
      placeholder: 'Numéro de compte',
    },
    jobFunction: {
      label: 'Fonction',
      placeholder: 'Fonction',
    },
    phoneNumber: {
      label: 'Numéro de téléphone',
      placeholder: 'Numéro de téléphone',
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Mot de passe',
    },
    newPassword: 'Nouveau mot de passe',
    emailMarketing: 'Utilisez mes renseignements personnels pour recevoir des infolettres de campagnes de marketing. Pour modifier vos paramètres, accédez à la gestion du consentement dans Mon compte.',
    confirmThatRead: 'Je confirme avoir lu et accepté les',
    selectTitle: 'Sélectionner le titre',
    passwordMinRequirements: 'Le mot de passe doit comporter au moins six caractères, dont une lettre majuscule, un chiffre et un symbole',
    bothPasswordMustMatch: 'Les deux mots de passe doivent être identiques',
    titleRequired: 'Le titre est obligatoire.',
    postRegisterMessage: 'Veuillez vous connecter avec les identifiants fournis.',
    pageHeader1: 'Inscription d\'un nouveau client',
    pageHeader2: 'Soumettez votre inscription ci-dessous',
  },
};
